import { AspectRatio, BookingPostType } from "../graphql/generated";

/**
 * Convert AspectRatio enum to CSS aspect ratio string
 */
export const aspectRatioToCSS = (aspectRatio: AspectRatio): string => {
  switch (aspectRatio) {
    case AspectRatio.Vertical_916:
      return "9/16";
    case AspectRatio.Vertical_45:
      return "4/5";
    case AspectRatio.Square:
      return "1/1";
    case AspectRatio.Landscape_169:
      return "16/9";
    default:
      return "1/1";
  }
};

/**
 * Derive aspect ratio from BookingPostType
 */
export const postTypeToAspectRatio = (postType: BookingPostType): string => {
  switch (postType) {
    case BookingPostType.BookingPostTypeStory:
      return "9/16"; // Stories are vertical 9:16
    case BookingPostType.BookingPostTypeFeed:
      return "4/5"; // Feed posts are 4:5
    case BookingPostType.BookingPostTypeReel:
      return "9/16"; // Reels are vertical 9:16
    case BookingPostType.BookingPostTypeTiktok:
      return "9/16"; // TikToks are vertical 9:16
    default:
      return "1/1"; // Default to square
  }
};